module.exports = __webpack_public_path__ + "static/media/bg-auth.283ac044.jpg";